import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  HostListener,
} from '@angular/core';
import { ModalService } from '../modal/modal.service';

@Component({
  selector: 'fcp-bottom-nav',
  templateUrl: './bottom-nav.component.html',
  styleUrls: ['./bottom-nav.component.scss'],
})
export class BottomNavComponent implements OnInit {
  @ViewChild('bottomNav', { static: true }) bottomNav: ElementRef;
  @ViewChild('dummy', { static: true }) dummy: ElementRef;

  @HostListener('window:scroll', ['$event'])
  public onWindowScroll(from?: any) {
    let bannerPosition = 0;
    const banner: any = document.getElementsByClassName('banner')[0];
    const bottomNavOffsetHeight = this.bottomNav.nativeElement.offsetHeight;
    const health = document.getElementsByClassName('health')[0];
    const newBanner: any = document.getElementsByClassName('block__new-banner')[0];
    if (banner && bottomNavOffsetHeight) {
      bannerPosition = banner.offsetHeight - bottomNavOffsetHeight;
    } else if (health) {
      bannerPosition = health.clientHeight;
    } else if (newBanner && bottomNavOffsetHeight) {
      bannerPosition = newBanner.offsetHeight - bottomNavOffsetHeight;
    }
    const dummyPosition = this.dummy.nativeElement.offsetHeight;
    if (window.pageYOffset >= bannerPosition) {
      this.bottomNav.nativeElement.classList.add('position-fixed');
    } else {
      this.bottomNav.nativeElement.classList.remove('position-fixed');
    }
    if (window.pageYOffset < dummyPosition) {
      this.bottomNav.nativeElement.classList.remove('position-fixed');
    }
  }

  constructor(private modalService: ModalService) {}

  ngOnInit() {}

  public openModal() {
    this.modalService.open({
      tabs: null,
      buttons: null,
      data: null,
      img: '',
      title: '',
      titleTabs: null,
      subtitleTabs: null,
      type: 'Rede Credenciada',
      text: null,
    });
  }
}
